/**
 * Chat Agent Types and Constants
 * Defines the 5 AI Agents and their configurations
 */


export enum ChatAgentType {
  AI = 'AI', // AI chatbot (Hỏi đáp)
  TAX_QUESTION = 'TAX_QUESTION', // AI hỏi đáp thuế
  INSTRUCTION_MANUAL = 'INSTRUCTION_MANUAL', // AI hướng dẫn sử dụng
  ANALYTICS_QUESTION = 'ANALYTICS_QUESTION', // AI hỏi đáp dữ liệu shop
  CSKH = 'CSKH', // AI hỏi đáp CSKH
}

export interface ChatAgentConfig {
  type: ChatAgentType;
  name: string;
  displayName: string;
  placeholder: string;
  icon: string;
  shortName: string,
  welcomeMessage: string
}



export const AGENT_CONFIGS: Record<ChatAgentType, ChatAgentConfig> = {
  [ChatAgentType.AI]: {
    type: ChatAgentType.AI,
    name: 'AI',
    displayName: 'agents.AI.displayName',
    placeholder: 'agents.AI.placeholder',
    icon: 'CommonQAIcon',
    shortName: 'agents.AI.shortName',
    welcomeMessage: 'agents.AI.welcomeMessage'
  },
  [ChatAgentType.TAX_QUESTION]: {
    type: ChatAgentType.TAX_QUESTION,
    name: 'Thuế',
    displayName: 'agents.TAX_QUESTION.displayName',
    placeholder: 'agents.TAX_QUESTION.placeholder',
    icon: 'TaxIcon',
    shortName: 'agents.TAX_QUESTION.shortName',
    welcomeMessage: 'agents.TAX_QUESTION.welcomeMessage'
  },
  [ChatAgentType.INSTRUCTION_MANUAL]: {
    type: ChatAgentType.INSTRUCTION_MANUAL,
    name: 'HDSD',
    displayName: 'agents.INSTRUCTION_MANUAL.displayName',
    placeholder: 'agents.INSTRUCTION_MANUAL.placeholder',
    icon: 'UserManualIcon',
    shortName: 'agents.INSTRUCTION_MANUAL.shortName',
    welcomeMessage: 'agents.INSTRUCTION_MANUAL.welcomeMessage'
  },
  [ChatAgentType.ANALYTICS_QUESTION]: {
    type: ChatAgentType.ANALYTICS_QUESTION,
    name: 'Số liệu',
    displayName: 'agents.ANALYTICS_QUESTION.displayName',
    placeholder: 'agents.ANALYTICS_QUESTION.placeholder',
    icon: 'DatabaseIcon',
    shortName: 'agents.ANALYTICS_QUESTION.shortName',
    welcomeMessage: 'agents.ANALYTICS_QUESTION.welcomeMessage'
  },
  [ChatAgentType.CSKH]: {
    type: ChatAgentType.CSKH,
    name: 'CSKH',
    displayName: 'agents.CSKH.displayName',
    placeholder: 'agents.CSKH.placeholder',
    icon: 'CustomerServiceIcon',
    shortName: 'agents.CSKH.shortName',
    welcomeMessage: 'agents.CSKH.welcomeMessage'
  },
};

